/**
 * sayknowwork-server REST 클라이언트 — admin 측.
 *
 * 토큰 저장: localStorage `swk_admin_token` (유저 대시보드의 swk_access_token 과 분리).
 * 개발/운영 모두 서버가 `/admin` 정적 빌드를 서빙하고, API는 같은 origin의 `/v1/*`를 호출한다.
 */

const STORAGE_KEY = 'swk_admin_token';
const TENANT_KEY = 'swk_admin_tenant_id';

export function getToken(): string | null {
  return typeof window === 'undefined' ? null : localStorage.getItem(STORAGE_KEY);
}

export function setToken(token: string, tenantId?: string): void {
  localStorage.setItem(STORAGE_KEY, token);
  if (tenantId) localStorage.setItem(TENANT_KEY, tenantId);
}

export function clearToken(): void {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(TENANT_KEY);
}

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const token = getToken();
  const res = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {}),
    },
  });
  const text = await res.text();
  let body: unknown;
  try {
    body = text ? JSON.parse(text) : undefined;
  } catch {
    body = text;
  }
  if (!res.ok) {
    if (res.status === 401 && token) {
      // 저장된 토큰이 만료/무효 — 정리 후 로그인 화면으로
      clearToken();
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('swk-admin-auth-cleared'));
      }
    }
    const msg =
      typeof body === 'object' && body !== null && 'error' in body
        ? String((body as { error: unknown }).error)
        : `HTTP ${res.status}`;
    throw new ApiError(res.status, msg, body);
  }
  return body as T;
}
